<template>
<el-row type="flex" justify="center">
	<el-col :xs="24" :sm="12" :md="10" :lg="8">
		<el-form label-position="top" label-width="100px">
			<p style="margin-bottom: 0;"><small>PROFILE</small></p>
			<h1 style="margin-top: 0;">{{ app.user.first_name }} {{ app.user.last_name }}</h1>
			<hr>
			<el-form-item label="First name:">
				<el-input @input="$v.credentials.first_name.$touch()" placeholder="Your first name" type="text" v-model.trim="first_name" :disabled="app.isLoading"></el-input>
				<div v-if="$v.credentials.first_name.$error">
					<span class="el-form-item__error">
						<span v-if="!$v.credentials.first_name.required">This field is required.</span>
					<span v-if="!$v.credentials.first_name.minLength">First Name must have at least {{$v.credentials.first_name.$params.minLength.min}} letters.</span>
					</span>
				</div>
			</el-form-item>

			<el-form-item label="Last name:">
				<el-input @input="$v.credentials.last_name.$touch()" placeholder="Your last name" type="text" v-model.trim="last_name" :disabled="app.isLoading"></el-input>
				<div v-if="$v.credentials.last_name.$error || $v.credentials.last_name.$invalid">
					<span class="el-form-item__error">
						<span v-if="!$v.credentials.last_name.required">This field is required.</span>
					<span v-if="!$v.credentials.last_name.minLength">First Name must have at least {{$v.credentials.last_name.$params.minLength.min}} letters.</span>
					</span>
				</div>
			</el-form-item>

			<el-form-item label="Location:">
				<el-input @input="$v.credentials.location.$touch()" placeholder="Your location" type="text" v-model.trim="location" :disabled="app.isLoading"></el-input>
				<div v-if="$v.credentials.location.$error">
					<span class="el-form-item__error">
						<span v-if="!$v.credentials.location.required">This field is required.</span>
					<span v-if="!$v.credentials.location.minLength">First Name must have at least {{$v.credentials.location.$params.minLength.min}} letters.</span>
					</span>
				</div>
			</el-form-item>

			<el-form-item label="Email:">
				<el-input @input="$v.credentials.email.$touch()" placeholder="Your email" type="email" v-model.trim="email" :disabled="app.isLoading"></el-input>
				<div v-if="$v.credentials.email.$error">
					<span class="el-form-item__error"><span v-if="!$v.credentials.email.required">This field is required.</span><span v-if="!$v.credentials.email.email">Must be a valid email.</span></span>
				</div>
			</el-form-item>

			<el-form-item label="VIN Number:">
				<el-input @input="$v.credentials.vin_chassis_no.$touch()" placeholder="Your first name" type="text" v-model.trim="app.user.vin_chassis_no" :disabled="true" :readonly="true"></el-input>
			</el-form-item>

			<el-form-item label="Vehicle model:">
				<el-select v-model="app.user.vehicle_model" :disabled="true" :readonly="true">
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="Currency:">
				<el-select v-model="currency" :disabled="app.isLoading">
					<el-option v-for="(symbol, iso) in app.currencySymbols" :key="iso" :label="iso + ' ('+ symbol +')'" :value="iso">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="Prefered Units:">
				<el-radio-group v-model="units" :disabled="app.isLoading">
					<el-radio label="km">Kilometers</el-radio>
					<el-radio label="miles">Miles</el-radio>
				</el-radio-group>
			</el-form-item>

			<h3>Security</h3>
			<p><small>Leave this blank if you don't want to change you password.</small></p>

			<el-form-item label="Password:">
				<el-input @input="$v.credentials.password.$touch()" placeholder="Password" type="password" v-model.trim="credentials.password" :disabled="app.isLoading"></el-input>
				<span v-if="$v.credentials.password.$error">
				<span class="el-form-item__error" v-if="!$v.credentials.password.minLength">Email must have at least {{$v.credentials.password.$params.minLength.min}} characters.</span>
				</span>
			</el-form-item>

			<el-form-item label="Repeat Password:">
				<el-input @input="$v.credentials.repeatPassword.$touch()" placeholder="Password" type="password" v-model.trim="credentials.repeatPassword" :disabled="app.isLoading"></el-input>
				<span v-if="$v.credentials.repeatPassword.$error">
					<span class="el-form-item__error">
						<span v-if="!$v.credentials.repeatPassword.requiredIfPassword">Field is required.</span>
				<span v-if="!$v.credentials.repeatPassword.sameAsPassword">Passwords must be identical.</span>
				</span>
				</span>
			</el-form-item>
			<hr>
			<p>
				<el-button type="primary" @click="update()" :disabled="$v.$invalid || app.isLoading" :loading="app.isLoading">
					Update
				</el-button>
			</p>
		</el-form>
	</el-col>
</el-row>
</template>

<script>
import { required, sameAs, minLength, email } from "vuelidate/lib/validators";
import axios from "axios";
import * as auth from "@/utils/auth";
import { getToken } from "@/utils/auth";
import router from "@/router";
import store from "@/utils/store";
import { PROFILE_URL } from "@/config";

export default {
	name: "profile",
	data() {
		return {
			app: store,
			credentials: {
				first_name: "",
				last_name: "",
				email: "",
				location: "",
				currency: "",
				units: "",
				password: "",
				repeatPassword: ""
			},
			options: [
				{
					value: "Toyota Mirai",
					option: "Toyota Mirai"
				},
				{
					value: "Hyundai ix35",
					option: "Hyundai ix35"
				},
				{
					value: "Honda Clarity",
					option: "Honda Clarity"
				},
				{
					value: "Symbio",
					option: "Symbio"
				},
				{
					value: "Other",
					option: "Other"
				}
			]
		};
	},
	validations: {
		credentials: {
			first_name: {
				required,
				minLength: minLength(3)
			},
			last_name: {
				required,
				minLength: minLength(3)
			},
			email: {
				required,
				email
			},
			location: {
				required,
				minLength: minLength(4)
			},
			password: {
				minLength: minLength(6)
			},
			repeatPassword: {
				sameAsPassword: sameAs("password")
			}
		}
	},
	computed: {
		first_name: {
			get() {
				return (this.credentials.first_name = this.app.user.first_name);
			},
			set(newValue) {
				this.credentials.first_name = newValue;
			}
		},
		last_name: {
			get() {
				return (this.credentials.last_name = this.app.user.last_name);
			},
			set(newValue) {
				this.credentials.last_name = newValue;
			}
		},
		email: {
			get() {
				return (this.credentials.email = this.app.user.email);
			},
			set(newValue) {
				this.credentials.email = newValue;
			}
		},
		location: {
			get() {
				return (this.credentials.location = this.app.user.location);
			},
			set(newValue) {
				this.credentials.location = newValue;
			}
		},
		currency: {
			get() {
				return (this.credentials.currency = this.app.user.currency);
			},
			set(newValue) {
				if (this.app.user.currency !== newValue) {
					this.app.user.currency = newValue;
				}
				this.credentials.currency = newValue;
			}
		},
		units: {
			get() {
				return (this.credentials.units = this.app.user.units);
			},
			set(newValue) {
				if (this.app.user.units !== newValue) {
					this.app.user.units = newValue;
				}
				this.credentials.units = newValue;
			}
		}
	},
	methods: {
		getToken,
		update() {
			if (this.$v.$invalid) return;
			let _self = this;
			axios({
				method: "put",
				url: PROFILE_URL,
				data: this.$data.credentials,
				headers: {
					Authorization: `Bearer ${auth.getToken()}`
				}
			})
				.then(function(response) {
					window.scrollTo(0, 0);
					auth.setToken(response.headers["x-new-token"]);
					auth.setUser(response.data);
					return (_self.app.messages = [
						`Your details have now been updated`
					]);
				})
				.catch(function(error) {
					let response = error.response;
					auth.setToken(response.headers["x-new-token"]);
					return (_self.app.messages = [response.data.message]);
				});
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
</style>



// WEBPACK FOOTER //
// Profile.vue?7944df20